import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  questions: [],
  preferences: {
    count: 1,
    options: 4,
    type: 'mcq',
    multiOptions: 'mcq',
    optionType: 'single',
    selectedLanguage: 'text',
    levels: 'easy',
    classes: [],
    subject: '',
    classType: '',
    classRoomId: '',
    courseId: '',
    sectionId: '',
    contentId: '',
    semester: '',
    streamName: '',
    otherName: '',
    quizGroup: ''
  },
  questionEdit: false
};

const addQuestionsBank = createSlice({
  name: 'addQuestionsBank',
  initialState,
  reducers: {
    addquestions(state: any, action) {
      state.questions = action.payload;
    },
    updatequestions(state: any, action) {
      const updatedQuestion = action.payload;
      const existingIndex = state.questions?.findIndex((q: any) => q._id === updatedQuestion._id);

      if (existingIndex !== -1) {
        return {
          ...state,
          questions: state.questions?.map((q: any, idx: number) => (idx === existingIndex ? updatedQuestion : q))
        };
      } else {
        return {
          ...state,
          questions: [...state.questions, updatedQuestion]
        };
      }
    },
    deletequestion(state: any, action) {
      state.questions = state.questions.filter((question: any) => question._id !== action.payload);
    },
    addPreferences(state: any, action) {
      state.preferences = action.payload;
    },
    updatePreference(state, action) {
      const { payload } = action;
      if (payload && typeof payload === 'object') {
        state.preferences = { ...state.preferences, ...payload };
      }

    },
    editQuestion(state: any, action) {
      if (!action.payload) {
        state.preferences = initialState.preferences;
      }
      state.questionEdit = action.payload;
    }
  }
});

export const { addquestions, updatequestions, deletequestion, addPreferences, updatePreference, editQuestion } = addQuestionsBank.actions;
export default addQuestionsBank.reducer;
